import React from "react";
import { createPortal } from "react-dom";

const Spinner = () => {
  if (typeof document === "undefined") {
    return null;
  }

  return createPortal(
    <div style={styles.overlay} role="status" aria-label="Loading">
      <div style={styles.loader} />
    </div>,
    document.body
  );
};

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(21, 36, 86, 0.85)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 99999,
  },
  loader: {
    border: "5px solid rgba(255, 255, 255, 0.25)",
    borderTop: "5px solid #2490EA",
    borderRadius: "50%",
    width: 48,
    height: 48,
    animation: "spin 0.8s linear infinite",
  },
};

export default Spinner;
